import queryString from 'query-string';

const parseQuery = (s: string) => queryString.parse(s);
const stringifyQuery = (query: { [key: string]: any }) => queryString.stringify(query);

export { parseQuery, stringifyQuery };
